// extracted by mini-css-extract-plugin
export default {"root":"FamilyQuota__root--3EoJB","titleBlock":"FamilyQuota__titleBlock--oV9Vv","root_mobile":"FamilyQuota__root_mobile--2hOuD","title":"FamilyQuota__title--1l8Bw"};